module.exports = __webpack_public_path__ + "img/IMG_20220207_142737 - Copy.b6d73048.jpg";